import {FaLinkedin, FaSalesforce, FaHubspot, FaShopify } from "react-icons/fa";
import { SiGoogleanalytics, SiGoogleads, SiMeta } from "react-icons/si";

const channelsList = [
  {
    name: "Google Analytics 4",
    icon: <SiGoogleanalytics color="gold" />,
    key: "ga",
  },
  {
    name: "Google Ads",
    icon: <SiGoogleads color="gold" />,
    key: "gads",
  },
  {
    name: "Meta Ads",
    icon: <SiMeta color="#4267B2" />,
    key: "meta",
    // status: "coming-soon",
  },
  {
    name: "LinkedIn Ads",
    icon: <FaLinkedin color="blue" />,
    key: "linkedin",
  },
  {
    name: "Salesforce",
    icon: <FaSalesforce color="#00A1E0" />,
    key: "salesforce",
    status: "coming-soon",
  },
  {
    name: "HubSpot",
    icon: <FaHubspot color="#FF7A59" />,
    key: "hubspot",
    status: "coming-soon",
  },
  {
    name: "Shopify",
    icon: <FaShopify color="#96bf48" />,
    key: "shopify",
    status: "coming-soon",
  },
];
const findChannel = (name) => channelsList.find(c => c.name === name);

export const getChannelIcon = (key) => {
  const channel = channelsList.find(c => c.key === key);
  return channel ? channel.icon : null;
};

export const categories = [
  {
    name: "Paid Advertising",
    channels: [
      findChannel("Google Ads"),
      findChannel("Meta Ads"),
      findChannel("LinkedIn Ads")
    ],
  },
  {
    name: "Analytics",
    channels: [findChannel("Google Analytics 4")],
  },
  {
    name: "CRM",
    channels: [
      findChannel("Salesforce"),
      findChannel("HubSpot")
    ],
  },
  {
    name: "Ecommerce",
    channels: [findChannel("Shopify")],
  }
];

export default function ChannelCategories() {
  return null;
}